import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function DeleteEvent() {
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const API_URL = BASE_URL + "/getevents";

  useEffect(() => {
    axios
      .get(API_URL, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setEvents(res.data);
        setLoading(false);
        setShowModal(true); // ✅ open modal after data loads
      })
      .catch((error) => {
        console.log("There was an error", error);
      });
  }, [API_URL]);

  const deleteEvent = () => {
    const DELETE_URL = BASE_URL + `/deleteevent/${id}`;
    axios
      .delete(DELETE_URL, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setShowModal(false);
        navigate("/events");
      })
      .catch((error) => {
        console.log("There was an error", error);
      });
  };

  if (loading) return <Loader />;

  const event = events.find((e) => e.Id === id);

  return (
    <>
      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowModal(false);
                    navigate("/events");
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {event ? (
                  <p>
                    Are you sure you want to delete{" "}
                    <b>{event.eventName}</b> (
                    <i>{event.sportCategory}</i>)?
                  </p>
                ) : (
                  <p>Event not found</p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowModal(false);
                    navigate("/events");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={deleteEvent}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
